module.exports = __webpack_public_path__ + "static/media/004-microphone.0d096d63.svg";